import { Box } from "@mui/material";
import { Copyright } from "app/components";
import { Outlet } from "react-router-dom";

export function AppLayout() {
  return (
    <Box>
      <Outlet />

      <Copyright />
    </Box>
  );
}
